import React, { useState } from "react";
import "./style.css";
import { AiOutlineSearch } from "react-icons/ai";
import { IoIosArrowDown } from "react-icons/io";
import { Collapse } from "react-collapse";
//import { NavLink } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import ConsultasPendentes from '../../../components/Display_ProfissionalSaude/Listar_Consultas/Pendentes';
import ConsultasPassadas from '../../../components/Display_ProfissionalSaude/Listar_Consultas/Passadas';
import ConsultasConfirmadas from '../../../components/Display_ProfissionalSaude/Listar_Consultas/Confirmadas';
import SideNav from './../../../components/SideNav_PS';
import Logout from './../../../components/Button_Logout';

export default function Tela_PS_Painel() {
    let [search, setSearch] = useState(false);
    let [options, setOptions] = useState(false);
    let [options2, setOptions2] = useState(false);
    let [options3, setOptions3] = useState(false);
    
    return (
        <>
        <SideNav />
        <div id="top-PS">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">     
                <Logout />
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>   
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"> 
                <Collapse isOpened={search}>
                    <input id="Tela_PS" type="text" placeholder="pesquisa..." />
                </Collapse>
                <AiOutlineSearch
                    size={"6vh"}
                    onClick={() =>
                        setSearch(!search)
                    }
                    id="Icon-Search-PS"
                />
            </Grid>
        </Grid>
        </div>
            <div id="main-PS-Painel">
                <div id="actions-PS-Painel">
                    <p id="PS-Painel">Consultas Pendentes</p>
                    <hr id="divider-PS-Painel" />
                    <div id="arrow-PS-Painel">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions(!options)
                            }
                            size={"6vh"}
                            id="IconDown-PS-Painel"
                        />
                    </div>
                    <Collapse isOpened={options}>
                        <div id="collapsed-PS_Painel">
                            <ConsultasPendentes />
                        </div>
                    </Collapse>
                </div>
                <div id="actions-PS-Painel">
                    <p id="PS-Painel">Consultas Confirmadas</p>
                    <hr id="divider-PS-Painel" />
                    <div id="arrow-PS-Painel">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions2(!options2)
                            }
                            size={"6vh"}
                            id="IconDown-PS-Painel"
                        />
                    </div>
                    <Collapse isOpened={options2}>
                        <div id="collapsed-PS_Painel">
                            <ConsultasConfirmadas />
                        </div>
                    </Collapse>
                </div>
                <div id="actions-PS-Painel">
                    <p id="PS-Painel">Consultas Passadas</p>
                    <hr id="divider-PS-Painel" />
                    <div id="arrow-PS-Painel">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions3(!options3)
                            }
                            size={"6vh"}
                            id="IconDown-PS-Painel"
                        />
                    </div>
                    <Collapse isOpened={options3}>
                        <div id="collapsed-PS_Painel">
                            <ConsultasPassadas />
                        </div>
                    </Collapse>
                </div>
            </div>
        </>
    );
}